import React, { useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDropzone } from "react-dropzone";
import noImage from "./UploadIcon.png";
import Button from "../Button";
import prettyBytes from "pretty-bytes";

const useStylesFiles = makeStyles(() => ({
  dropzoneRoot: {
    background: "#F2F4F7",
    border: "1px dashed #596E79",
    boxSizing: "border-box",
    borderRadius: "10px",
    minWidth: "120px",
    height: "128px",
    display: "flex",
    padding: "30px 30px 20px 30px",
    "& > img": {
      width: "80px",
      height: "50px"
    }
  },
  buttonDropzone: {
    display: "flex",
    alignItems: "center",
    "& > span": {
      fontSize: 12,
      color: "#000000",
      marginLeft: 25
    }
  },
  caption: {
    marginTop: 10,
    "& div": {
      fontSize: 10,
      color: "#778899"
    }
  },
  captionBlock: {
    marginLeft: 35
  }
}));

const useStylesPhoto = makeStyles(() => ({
  dropzoneRoot: {
    background: `url(${noImage}) no-repeat center #E9ECF7`,
    border: "2px dashed #CACCD1",
    boxSizing: "border-box",
    width: "240px",
    height: "160px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    cursor: "pointer"
  }
}));

export default function UploadDropzone({ onDrop, accept, maxSize, type, fileId }) {
  const classesFile = useStylesFiles();
  const classesPhoto = useStylesPhoto();
  const baseURL = "/work/api/file";

  const onDropCallback = useCallback(
    acceptedFiles => {
      onDrop(acceptedFiles);
    },
    [onDrop]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: onDropCallback,
    accept,
    maxSize
  });

  const acceptedString = React.useMemo(() => {
    if (Array.isArray(accept)) {
      return accept.join(",");
    }
    return accept;
  }, [accept]);

  return type === "card" ? (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <div className={classesPhoto.dropzoneRoot}
  style={fileId && {background: `url(${baseURL}/${fileId})  no-repeat center`, backgroundSize: "contain"}}/>
    </div>
  ) : (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <div className={classesFile.dropzoneRoot}>
        <img src={noImage} alt=""/>
        <div className={classesFile.captionBlock}>
          <div className={classesFile.buttonDropzone}>
            <Button>Выбрать файл</Button>
            <span>или перетащите сюда</span>
          </div>
          <div className={classesFile.caption}>
            <div>Допустимые расширения: {acceptedString}</div>
            <div>Максимальный размер файла: {prettyBytes(maxSize)}.</div>
          </div>
        </div>
      </div>
    </div>
  );
}
